module.exports = __webpack_public_path__ + "static/media/CTLI_15-444w.53d57984.webp";